import React from 'react';  
import './index.css';
 
class HomeTitle extends React.Component{
 
 handleClick(){
  this.props.skip()
 }
  render(){
    const {imgUrl} =this.props;
    return (
      <div className="sub-title">
        <span className="sub-title-icon">
          <img src={`${require('./img/'+imgUrl+'.png')}`} alt=""/>
          {this.props.title}
        </span>
        <div className="changeBtn"  onClick={()=>{this.handleClick()}}>
          <span>更多</span>
          <img src={require('./img/icon_right.png')} alt=""/>
        </div>
      </div>
      )
  }
}
export default HomeTitle;